import { SIGNUP_NEW } from '../Types';
import createUser from './createUser';

/**
 * Signup a new user and team
 */
export const signUpNew = (signUpDetails) => {
  return (dispatch, getState) => {
    const action = {
      type: SIGNUP_NEW,
      request: async (apiClient) => {
        try {
          const { existingUser } = getState();

          const { firstName, lastName, fullName, ...rest } = signUpDetails;

          const customerFullName = firstName && lastName ? `${firstName} ${lastName}` : fullName;

          if (!existingUser)
            await createUser(
              apiClient,
              { ...rest, fullName: customerFullName },
            );

          const { email, industry, referral } = signUpDetails;
          let { phone, teamName, timezone } = signUpDetails;

          if (!teamName) {
            teamName = `${customerFullName}'s Team`;
          }

          //create new team
          const teamDetails = {
            title: teamName,
            email: existingUser ? existingUser.email : email,
            industry,
            referral,
            defaultTimeZone: timezone
          };

          if (phone) {
            teamDetails.phone = phone;
          }

          const team = await apiClient.team.create(teamDetails);
          return team;
        } catch (error) {
          if (error.response?.status === 409) {
            dispatch({
              type: `${SIGNUP_NEW}_FAILURE`,
            });
            return;
          }
          throw error;
        }
      },
    };

    dispatch(action);
  };
};

export default signUpNew;
